export const TOAST_CONTAINER_CLASS_NAME = 'ui-modal-toast-container'
